import AuthModule from '@/store/Auth';
import BookingModule from '@/store/Booking';
import RouterModule from '@/store/Router';
import SnackModule from '@/store/Snack';
import Vue from 'vue';
import Vuex from 'vuex';
import { getModule } from 'vuex-module-decorators';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    AuthModule,
    SnackModule,
    RouterModule,
    BookingModule,
  },
});

export const authModule = getModule(AuthModule, store);
export const snackModule = getModule(SnackModule, store);
export const routerModule = getModule(RouterModule, store);
export const bookingModule = getModule(BookingModule, store);

authModule.addLoginHook(authModule.getUserSubscriptions);
// authModule.addLogoutHook(myModule.myLogoutHook);

export default store;
